import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  DBModalService,
  DBPanelModule,
  DBToggleableModule,
  DBButtonModule,
  DBSpinnerModule,
  DBModalModule,
  DBIconModule
} from '@db/db-core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { delay, map, Observable, shareReplay, startWith, Subject, switchMap } from 'rxjs';
import { ModalInfo } from 'src/app/core/interfaces/common';
import { CommonService } from 'src/app/shared/services/common.service';
import { environment } from 'src/environments/environment.generated';
import {getAppThemeName} from "../../../core/functions/common.function";
import { CommonModule } from '@angular/common';
import { DedupeByPropertyPipe } from 'src/app/shared/pipes/dedupe-by-property.pipe';

@Component({
  selector: 'app-consent-granted-state',
  templateUrl: './consent-granted-state.component.html',
  styleUrls: ['./consent-granted-state.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DBPanelModule,
    DBToggleableModule,
    DBButtonModule,
    DBSpinnerModule,
    DBModalModule,
    DBIconModule,
    DedupeByPropertyPipe,
  ]
})
export class ConsentGrantedStateComponent implements OnInit {
  @ViewChild('modalTemplate', {
    read: TemplateRef,
    static: true
  })
  public modalTemplateRef!: TemplateRef<any>;
  public scopes: Array<any> = [];
  public readyToRevokeIndex = '';
  public modalBody = '';
  public activeLang: string = '';
  public accordionModal: any;
  public modalInfo: ModalInfo = {
    modalTitle: '',
    modalBody: '',
    activeBtnText: '',
    inactiveBtnText: ''
  };
  public loadingRevoke = false;
  readonly processorDrivers$!: Observable<any[]>;
  private readonly refresh$ = new Subject<void>();

  constructor(
    private appService: CommonService,
    private translate: TranslateService,
    private modalService: DBModalService
  ) {
    this.processorDrivers$ = this.refresh$.pipe(
      startWith(void 0),
      switchMap(() => this.appService.getRequestExternal(environment.endPoints.processorDrivers, [], [])),
      map(resp => {
        console.log(`this.processorDrivers:`);
        console.log(resp.processorDrivers);
        return resp.processorDrivers ?? [];
      }),
      shareReplay(1)
    );
    this.setLangInfo();
  }

  ngOnInit(): void { }

  onRevokeButtonClick(processorDriverId: string, processorDriverName: string) {
    this.setLangInfo();
    this.modalInfo.modalBody = `${this.modalBody} ${processorDriverName}?`;
    this.readyToRevokeIndex = processorDriverId;
    this.modalService.openWithTemplate(this.modalTemplateRef, { closeOnBackdropClickOrEscKey: false });
  }

  setLangInfo() {
    this.translate.get('PERMISSION_GRANT.accordion_sec.header.revoke_popup').subscribe(langData => {
      this.modalBody = `${langData.body}`;
      this.modalInfo = {
        modalTitle: langData.title,
        modalBody: '',
        activeBtnText: langData.cancel,
        inactiveBtnText: langData.yes
      };
    });
  }

  getActiveLang() {
    return this.translate.currentLang === 'en' ? 'ENGLISH' : 'GERMAN';
  }

  revokeProcessorDriverConsents() {
    this.loadingRevoke = true;
    const payload = { status: "REVOKED" };
    this.appService.patchRequestExternal(`${environment.endPoints.processorDrivers}/${this.readyToRevokeIndex}`, payload, [])
      .pipe(delay(200))
      .subscribe({
        next: resp => {
          if (!environment.production) console.log(`PATCH response:`);
          if (!environment.production) console.log(resp);
          this.closeModal();
          this.refresh$.next();
        },
        error: err => {
          this.closeModal();
        }
    });
  }

  public closeModal(): void {
    this.loadingRevoke = false;
    this.modalService.close();
  }

  protected readonly getAppThemeName = getAppThemeName;
}
